import { AlertTriangle, ArrowRight, Home, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export const AgentPortalUnavailable = ({ requestedSlug }) => {
  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,_rgba(212,175,55,0.14),_transparent_28%),linear-gradient(180deg,#f7f3ea_0%,#f3eee4_40%,#efe8da_100%)] px-4 py-10 sm:px-6 lg:px-8" data-testid="agent-portal-unavailable-page">
      <div className="mx-auto max-w-4xl rounded-[36px] border border-[#001935]/10 bg-white/92 p-8 shadow-[0_24px_70px_rgba(0,25,53,0.08)] md:p-10">
        <div className="flex flex-wrap items-start justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/28 bg-[#fffaf1] px-4 py-2 text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="agent-portal-unavailable-badge">
              <AlertTriangle className="h-4 w-4" /> Agent portal unavailable
            </div>
            <h1 className="mt-5 text-4xl font-semibold leading-tight text-[#001935] sm:text-5xl" data-testid="agent-portal-unavailable-heading">
              We couldn&apos;t find an active agent portal for <span className="text-[#8b6d16]">/agent/{requestedSlug || "unknown"}</span>.
            </h1>
            <p className="mt-5 text-sm leading-8 text-[#42566f] sm:text-base" data-testid="agent-portal-unavailable-copy">
              This route is reserved for active agent portals only. If this portal was just launched, complete the latest provisioning or redeployment step and try again.
            </p>
          </div>

          <div className="rounded-[28px] border border-[#001935]/10 bg-[#fffaf1] p-5 text-sm leading-7 text-[#42566f]" data-testid="agent-portal-unavailable-info-card">
            <div className="flex items-center gap-2 text-[#8b6d16]"><ShieldCheck className="h-4 w-4" /><p className="text-xs font-bold uppercase tracking-[0.16em]">Why this appears</p></div>
            <ul className="mt-3 space-y-2">
              <li>• The slug does not map to an active agent record yet</li>
              <li>• The portal may still need provisioning or redeployment</li>
              <li>• The agent may not have subdomain access on the current environment</li>
            </ul>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-3" data-testid="agent-portal-unavailable-actions">
          <Link className="gold-button !px-5 !py-3" data-testid="agent-portal-unavailable-home-link" to="/">
            <Home className="mr-2 h-4 w-4" /> Back to Main Site
          </Link>
          <Link className="outline-button" data-testid="agent-portal-unavailable-live-example-link" to="/agent/clive">
            <ArrowRight className="mr-2 h-4 w-4" /> View Live Example Portal
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AgentPortalUnavailable;